import { useTranslation } from "react-i18next"
import { Link, Navigate, Outlet, useMatch } from "react-router"

import { AuthenticatedPageLayout } from "@/components/authenticated-page-layout"
import { PageHeaderNavigation } from "@/components/nav/page-header-navigation"
import { useActiveOrganizationId, useAuthentication } from "@/contexts"
import { DataPath, RootPath } from "@/models/route"
import { useFlags } from "@/services/feature"

import { Tab, Tabs } from "@mui/material"

export const DataIndexRoute: React.FC = () => {
  const { t } = useTranslation()
  const flags = useFlags()
  const { activeOrganizationId } = useActiveOrganizationId()
  const { isAdminWriterUser, isOrgAdminUser } = useAuthentication()

  const indexMatch = useMatch(`${activeOrganizationId}/${RootPath.Data}`)
  const uploadMatch = useMatch(
    `${activeOrganizationId}/${RootPath.Data}/${DataPath.Upload}`
  )
  const qaMatch = useMatch(
    `${activeOrganizationId}/${RootPath.Data}/${DataPath.QA}`
  )
  const outlierMatch = useMatch(
    `${activeOrganizationId}/${RootPath.Data}/${DataPath.Outlier}`
  )

  if (indexMatch) {
    return (
      <Navigate
        to={
          flags.data_manager_upload || isAdminWriterUser || isOrgAdminUser
            ? DataPath.Upload
            : DataPath.QA
        }
        replace={true}
      />
    )
  }

  let activeTabPath = ""

  if (uploadMatch) {
    activeTabPath = DataPath.Upload
  } else if (qaMatch) {
    activeTabPath = DataPath.QA
  } else if (outlierMatch) {
    activeTabPath = DataPath.Outlier
  }

  return (
    <AuthenticatedPageLayout
      secondary={
        <PageHeaderNavigation>
          {/* MUI 6 does not put aria-label on <nav> element */}
          {/* So must use it manually */}
          <nav aria-label={t("tab.label", { ns: "data" })}>
            <Tabs sx={{ px: 3 }} value={activeTabPath}>
              {/* FeatureGuard doesn't work with tabs */}
              {(isAdminWriterUser ||
                isOrgAdminUser ||
                flags.data_manager_upload) && (
                <Tab
                  component={Link}
                  label={t("tab.upload", { ns: "data" })}
                  to={DataPath.Upload}
                  value={DataPath.Upload}
                />
              )}
              <Tab
                component={Link}
                label={t("tab.qa", { ns: "data" })}
                to={DataPath.QA}
                value={DataPath.QA}
              />
              {flags.data_manager_outlier_monitor && (
                <Tab
                  component={Link}
                  label={t("tab.outlier", { ns: "data" })}
                  to={DataPath.Outlier}
                  value={DataPath.Outlier}
                />
              )}
            </Tabs>
          </nav>
        </PageHeaderNavigation>
      }
      title={t("moduleTitle.data", { ns: "common" })}
      wrapInPage={false}
    >
      <Outlet />
    </AuthenticatedPageLayout>
  )
}
